import { dropStaleWithdrawal } from '@oo/store';

// Kopf und Fuß: Höhe des klebenden Kopfbereichs, schlanker Kopfbereich am Handy, Klappspalten der Fußzeile, Sprechblase des Maskottchens.
// Eigene Datei, damit oo-theme.js unter der Größengrenze aus .theme-check.yml bleibt.
// Rendert der Theme-Editor Kopf oder Fuß neu (shopify:section:load), wird neu angemeldet statt am alten Element zu hängen.

const narrow = window.matchMedia('(max-width: 599.98px)');

// Höhe des klebenden Kopfbereichs als --oo-header-h: Sprungziele und andere klebende Elemente landen darunter.
let headerObserver = null;
function initHeaderHeight() {
  headerObserver?.disconnect();
  headerObserver = null;
  const header = document.querySelector('.oo-header-section');
  if (!header || typeof ResizeObserver !== 'function') return;
  headerObserver = new ResizeObserver(() => {
    // Eine abgehängte Hülle (Theme-Editor) misst 0 px; dann nichts setzen, die neue meldet sich gleich selbst.
    if (!header.isConnected) return;
    document.documentElement.style.setProperty('--oo-header-h', `${Math.ceil(header.getBoundingClientRect().height)}px`);
  });
  headerObserver.observe(header);
}

// Am Handy beim Herunterscrollen schlanker Kopfbereich (Section-Einstellung, oo-header.css). Zwei Schwellen,
// damit er an der Grenze nicht flackert; ganz oben ist er immer vollständig.
const compactHeader = { element: null, on: false };
function updateCompactHeader() {
  const header = compactHeader.element;
  if (!header) return;
  const next = narrow.matches && window.scrollY > (compactHeader.on ? 120 : 200);
  if (next === compactHeader.on) return;
  compactHeader.on = next;
  header.classList.toggle('is-compact', next);
}

function initCompactHeader() {
  compactHeader.element = document.querySelector('.oo-header[data-oo-compact]');
  compactHeader.on = false;
  updateCompactHeader();
}

// Fußzeile: Shop und Service sind am Handy zugeklappt, darüber offen und lassen sich nicht schließen (oo-footer.css).
// Ohne JavaScript bleiben sie überall offen. Jedes Mal neu suchen, damit neu gerenderte Spalten mitkommen.
function applyFooterFolds(root = document) {
  root.querySelectorAll('details[data-oo-fold]').forEach((fold) => (fold.open = !narrow.matches));
}

// Sprechblase des Maskottchens (oo-header.liquid): einmal pro Besuch kurz nach dem Laden, verschwindet nach 8 s.
// Solange Maus oder Fokus darauf liegen, bleibt sie stehen.
function initMascotTip() {
  const tip = document.querySelector('[data-oo-mascot-tip]');
  if (!tip) return;
  try {
    if (sessionStorage.getItem('oo-mascot-tip')) return;
    sessionStorage.setItem('oo-mascot-tip', '1');
  } catch {
    // Ohne Speicher (privates Fenster) erscheint sie eben bei jedem Aufruf der Startseite.
  }
  const hide = () => {
    if (tip.matches(':hover, :focus-within')) {
      setTimeout(hide, 2000);
      return;
    }
    tip.classList.remove('is-open');
    setTimeout(() => (tip.hidden = true), 350);
  };
  setTimeout(() => {
    tip.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => tip.classList.add('is-open')));
    setTimeout(hide, 8000);
  }, 1200);
  tip.querySelector('[data-oo-mascot-tip-close]')?.addEventListener('click', () => {
    tip.classList.remove('is-open');
    tip.hidden = true;
  });
}

initHeaderHeight();
initCompactHeader();
applyFooterFolds();
initMascotTip();
// Abgebrochene Widerrufe: Datensatz nicht bis zum Schließen des Tabs liegen lassen (oo-store.js).
dropStaleWithdrawal();

window.addEventListener('scroll', updateCompactHeader, { passive: true });
narrow.addEventListener('change', () => {
  updateCompactHeader();
  applyFooterFolds();
});
document.addEventListener('click', (event) => {
  if (!narrow.matches && event.target.closest('details[data-oo-fold] > summary')) event.preventDefault();
});

// Nur im Theme-Editor: neu gerenderter Kopf bzw. Fuß. Andere Sections klappen die Spalten nicht ungefragt neu.
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (!(section instanceof Element)) return;
  if (section.matches('.oo-header-section')) {
    initHeaderHeight();
    initCompactHeader();
  }
  if (section.querySelector('details[data-oo-fold]')) applyFooterFolds(section);
});
document.addEventListener('shopify:section:unload', (event) => {
  if (event.target instanceof Element && event.target.matches('.oo-header-section')) {
    headerObserver?.disconnect();
    headerObserver = null;
  }
});
